import React, { FC } from 'react'

interface Props {
   isToggled: boolean
   onClick: () => void
}

export const ControlButton: FC<Props> = ({ isToggled, onClick }) => (
   <div
      className={
         "note-creator__suggestion-control" +
         (isToggled ? " note-creator__suggestion-control_active" : "")
      }
      onClick={onClick}
      title="Control"
   >
      <span>/</span>
   </div>
)

export default ControlButton